import { DDMM } from '@witmetrics/utils/constants';
import { theme } from '@/utils/theme';
import { ACCENT_COLORS, TEXT_COLORS } from '@/constants/colors';
import { FIELD_WIDTH } from './constants';

export const classes = {
  wrapper: 'place-center gap-2 px-6 pt-6 pb-1',
  separator: 'text-taupe-2 text-xs shrink-0',
};

export const styles = {
  // Mirrors the witmetrics-unison TextField theme defaults
  field: {
    width: `${FIELD_WIDTH}px`,
    '& .MuiInputBase-root': {
      borderRadius: theme.shape.rounded['2xl'],
    },
    '& .MuiInputBase-root .MuiOutlinedInput-notchedOutline': {
      transition: 'border-color 0.2s',
    },
    '& .MuiInputBase-root:not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline, & .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline':
      {
        borderColor: ACCENT_COLORS.primary,
      },
    '& .MuiInputBase-input': {
      color: TEXT_COLORS.primary,
    },
  },
};

export function getFieldFormat(dateFormat?: string) {
  return dateFormat === DDMM ? 'dd/MM/yyyy' : 'MM/dd/yyyy';
}
